function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 31,
  height: 31,
  rx: 4.5,
  fill: "#fff"
}), React.createElement("path", {
  d: "M27,1a4,4,0,0,1,4,4V27a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V5A4,4,0,0,1,5,1H27m0-1H5A5,5,0,0,0,0,5V27a5,5,0,0,0,5,5H27a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
  fill: "#0074d9"
}), React.createElement("line", {
  x1: 7,
  y1: 16,
  x2: 25,
  y2: 16,
  fill: "none",
  stroke: "#6e7482",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), React.createElement("line", {
  x1: 16,
  y1: 25,
  x2: 16,
  y2: 7,
  fill: "none",
  stroke: "#6e7482",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
})));

function SvgAdd(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/add.4795607c.svg";
export { SvgAdd as ReactComponent };